import type React from 'react';
import { useState } from 'react';

import type { FaceId } from '@vlabs/api/luna-api/model';
import { ButtonSwitch, ButtonSwitchGroup } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { FaceAdditionalAttributes } from './face-additional-attributes';
import { FaceBasicAttributes } from './face-basic-attributes';
import st from './FaceAdditionalInfo.module.sass';

type SwitchState = 'attributes' | 'additional';

interface FaceAdditionalInfoProps {
  faceId: FaceId;
}

function FaceAdditionalInfo({
  faceId,
}: FaceAdditionalInfoProps): React.JSX.Element {
  const { t } = useTranslation();
  const [switchState, setSwitchState] = useState<SwitchState>('attributes');

  return (
    <div className={st.Root}>
      <ButtonSwitchGroup<SwitchState>
        onChange={setSwitchState}
        value={switchState}
        variant="square"
      >
        <ButtonSwitch value="attributes">
          {t('face-page:additional_info.switches.attributes')}
        </ButtonSwitch>
        <ButtonSwitch value="additional">
          {t('face-page:additional_info.switches.additional')}
        </ButtonSwitch>
      </ButtonSwitchGroup>
      {switchState === 'attributes' && <FaceBasicAttributes faceId={faceId} />}
      {switchState === 'additional' && <FaceAdditionalAttributes faceId={faceId} />}
    </div>
  );
}

export { FaceAdditionalInfo };
